import { render, staticRenderFns } from "./informationYssjk.vue?vue&type=template&id=db3d61c4&scoped=true&"
import script from "./informationYssjk.vue?vue&type=script&lang=js&"
export * from "./informationYssjk.vue?vue&type=script&lang=js&"
import style0 from "./informationYssjk.vue?vue&type=style&index=0&id=db3d61c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3d61c4",
  null
  
)

export default component.exports